<template>
<div>

  <v-card :id="story.StoryID" class="storyCard text-center" flat  color="m4u_tertiary"  
  :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'" >

  <div class="mediaBackground justify-center text-center" :width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'" >
        <v-lazy
        v-model="isActive"
        :options="{
          threshold: .5
        }"
      >
  <v-layout justify-center>
  <v-card 
    :width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'"
    class="justify-center text-center m4u_tertiary"
    flat
    height="100%"
  >  

    <div class="mediaDiv justify-center text-center" v-if="memory.MediaType !== 1">
      <a :href="sasKey" 
        target="popup" 
        onclick="window.open(sasKey,'popup','width=85vw,height=85vw'); return false;">
   <v-img 
      class="m4u_tertiary imageTag mx-auto"
      max-width="80%"
      max-height="100%"
      :src="sasKey"
    >
    </v-img>
      </a>
    </div>


    <div class="mediaDiv justify-center text-center" v-if="memory.MediaType === 1">
        <video controls controlsList="nodownload" :src="sasKey" 
          width ="85%" class="videoTag"></video>
    </div>

  </v-card>
  </v-layout>
        </v-lazy>
  </div>


<v-dialog
      v-model="readerDialog"
      fullscreen
       :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'"
    >
      <template v-slot:activator="{ on, attrs }">
  <v-layout justify-center v-bind="attrs"
          v-on="on"
          @click="openMemory(story.StoryID)">

    <v-card elevation="5" outlined class="m4u_tertiary mt-6" hidden
    :width ="$vuetify.breakpoint.xs ? '70vw' : '30vw'"           
    @mouseover="hover = true"
          @mouseleave="hover = false"
          :class="{ active: hover }">
    <v-card-text class="m4u_text--text storyHeight m4u_tertiary mt-5 left-text" >
      <v-row>
      <h2 class="storySummary m4u_text--text text-left" v-if="memory.StoryTypeID === 2"> Interview of {{memory.Interviewee}}:</h2></v-row>
      <v-row>
      <h4 class="storySummary m4u_text--text text-left">{{memory.StoryTitle}}</h4>
      </v-row>
      <v-row v-if="memory.StoryTypeID === 3">
      <h4  class="storySummary m4u_text--text">Ingredients:</h4>
      </v-row>
      <v-row>
      <p class="storySummary m4u_text--text mt-3 text-left" v-if="memory.StoryTypeID === 3"><pre>{{memory.StoryIngredients.slice(0,300)}}</pre></p>
      </v-row>

      <v-row  v-if="memory.StoryTypeID !== 3">
      <p class="m4u_text--text mb-2 text-left"><pre>{{memory.StoryText.slice(0,300)}}</pre></p>
      </v-row>
    </v-card-text>
    <v-card-text
     v-if="needsMore || memory.StoryTypeID === 3"><v-icon xs mt-3>mdi-dots-horizontal</v-icon>
     </v-card-text>
     <v-card-text>

     </v-card-text>
    </v-card>
  </v-layout>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{memory.StoryTitle}}<v-spacer></v-spacer>
           <v-btn
            color="primary"
            small
            text
            @click="resetMemory(memory.StoryID)"
          >
            <v-icon class="m4u_text--text">mdi-arrow-left</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <memoryreader key = "readerKey" :incomingStoryId="memory.StoryID" @closeReaderDialog="closeMemoryReader" 
          @memoryUpdate="resetMemory" @memoriesChanged="closeMemoryReader" />
        </v-card-text>

        <v-divider></v-divider>

      </v-card>
    </v-dialog>
  <v-layout justify-center>
    <p class="subtitle-1 ml-3 mt-3 m4u_text--text">{{memory.UserDisplayName}}, {{memory.date}}</p><br />
  </v-layout>

    <v-card-actions flat justify-space-between>
      <v-col
        md="4"
        lg="4"
        xl="4"
      >
      <v-row class="ml-3">
  <v-btn icon fab v-if="heartStatus === true" @click="changeHeartStatus()"><v-icon class="m4u_text_button--text text--accent-4">mdi-heart-multiple</v-icon></v-btn>
  <v-btn icon fab v-if="heartStatus !==  true"  @click="changeHeartStatus()"><v-icon>mdi-heart-multiple</v-icon></v-btn>
  <p class="pt-4 m4u_text_button--text" v-if="heartTotal > 0">{{heartTotal}}</p>
  </v-row>
        </v-col>
  
        <v-col
        md="4"
        lg="4"
        xl="4"
      >
      <v-row justify-center>

    <!---START DIALOG FOR ADD COMMENT --->
     <v-dialog
      v-model="commentDialog"
      persistent
      :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          icon
          fab
        >
         <v-icon class="m4u_text_button--text text--accent-4">mdi-message-outline</v-icon>
        </v-btn>
        <p class="pt-4 m4u_text_button--text" v-if="commentTotal > 0">{{commentTotal}}</p>
      </template>
      <v-card class="m4u_tertiary">

        <v-card-text>
          <v-container id="containerInStoryCard">
            <v-row>

        <v-textarea
        color="m4u_text"
        v-model="commentText"
        label="Add a comment"
        hint="Add a comment"
        auto-grow rows="2" rowHeight="10"
        ></v-textarea>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="m4u_text_button--text m4u_tertiary"
            text
            @click="commentDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            class="m4u_text_button--text m4u_tertiary"
            text
            @click="addComment()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  <p class="pt-4 m4u_text_button--text" v-if="commentTotal > 0">{{commentTotal}}</p>
  </v-row>
        </v-col>
    
      <v-col
        md="4"
        lg="4"
        xl="4"
      >
        <v-btn v-if="user.UserID === memory.Userid" @click="deletememorydialog=true" 
        color="m4u_tertiary" mx-6 > 
              <v-icon class="m4u_text_button--text">mdi-delete-alert-outline</v-icon></v-btn>
    <v-dialog
      v-model="deletememorydialog"
      fullscreen
      max-width="290"
    >
      <v-card>
      
          <h2 class="m4u_text--text">Are you sure you want to delete: {{memory.StoryTitle}}?</h2>

        <v-card-actions>
          <v-spacer></v-spacer>


          <v-btn
            color="red darken-1"
            text
            @click="deletememorydialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="deleteMemory()"
          >
           Delete
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
      </v-col>


    </v-card-actions>

  </v-card>


</div>

</template>
<script>

import EventService from '@/services/EventService.js'; 
import memoryreader from '../views/MemoryReader.vue';
import MediaCardHome from '../components/MediaCardHome.vue';

export default {
  name: "StoryCard",
  props: ["story"],

  components: {
    memoryreader,
    MediaCardHome
  },

  data() {
    return {
      isActive: false,
      sasKey: '',
      memory: [],
      myComment: '',
      cdialog: false,
      heartStatus: true,
      heartTotal: '',
      absolute: true,
      opacity: .5,
      overlay: false,
      needsMore: false,
      readerDialog: false,
      readerKey: 1,
      editMemory: false,
      commentTotal: 0,
      commentDialog: false,
      commentText: '',
      hover: false,
      deletememorydialog: false
       }
    },


    beforeMount() {


    this.memory = this.story;
    if(this.memory.MediaType === null){
      this.memory.MediaType = 2
    }
  },
    mounted() {
      this.getThisStory();
      this.startSASKey();
      this.getHeartStatus();
      this.getCommentTotal();
      this.setMoreButton();
    },
     computed: {
      user(){
        return this.$store.state.user
      }
  },

  methods: {

      async getThisStory() {
      EventService.getThisStory(this.story.StoryID)
      .then(
        (stories => {
          this.$set(this, "memory", stories[0]);
            this.$store.dispatch('setStory', this.story);
            this.startSASKey();
        }).bind(this)
      )
      .then(() => {
        this.setType(this.story.StoryTypeID)
      })},

    async setMoreButton() {
      if (this.memory.StoryText.length >= 200) {
      this.needsMore = true
    }
    },

      async setType(sentStoryID) {

          if (sentStoryID === 1) {
            this.TypeDesc = 'Memory';
            this.updateType = 1  
            this.toggle_exclusive = 1 }
          if (sentStoryID === 2) {
            this.TypeDesc = 'Interview'; 
            this.updateType = 2
            this.toggle_exclusive = 2 }
          if (sentStoryID === 3) {
            this.TypeDesc = 'Recipe';
            this.updateType = 3
            this.toggle_exclusive = 3 }
          if (sentStoryID === 4) {
            this.TypeDesc = 'Tradition'; 
            this.updateType = 4
            this.toggle_exclusive = 4 }
      },

    async resetMemory(resetStoryID) {
      this.editMemory=false;
      this.readerDialog=false;
    EventService.getThisStory(resetStoryID)
      .then(
        (memory => {
          this.$set(this, "memory", memory[0]);
        }).bind(this)
      )
      .then(() => {
      this.startSASKey();

      })
      .then(() => {
        this.$nextTick(() => {
      this.readerDialog=false;
        this.$emit('refreshList', true);
        this.readerKey = this.readerKey + 1
        this.getCommentTotal(this.memory.StoryID)
    })
      })
    },

    
        async deleteMemory() {
        await (EventService.deleteMemory(this.memory.StoryID))
        .then((returnDelete) => {})
        this.$parent.$emit('memoriesChanged', false);    
        this.$parent.$emit('refreshList', true);    
        },


    async closeMemoryReader() {
        this.readerDialog=false;
        this.$emit('refreshList', true);
        this.readerKey = this.readerKey + 1
        this.getCommentTotal(this.memory.StoryID)
    },

    async startSASKey() {
            if (this.memory.MediaLoc !== null) { 
              await this.getSASKey(this.memory.MediaLoc) }
      else {
        switch(this.memory.StoryTypeID) {
              case 1:
                this.sasKey = process.env.VUE_APP_IMAGEPATH + 'writing.png'
                return

              case 2:
               this.sasKey = process.env.VUE_APP_IMAGEPATH + 'interview.png'
               return

              case 3: 
                this.sasKey =  process.env.VUE_APP_IMAGEPATH + 'recipe8.png'
                return

              case 4:
               this.sasKey = process.env.VUE_APP_IMAGEPATH + 'traditions.png'
               return

              default:
                this.sasKey = process.env.VUE_APP_IMAGEPATH + 'writing.png'
      }
      }
    },

    async getSASKey() {
      await EventService.getSASKey(this.memory.MediaLoc)
      .then(
        (sasKey => {
          this.$set(this, "sasKey", sasKey);
        }).bind(this)
      )
            .then (
        this.$nextTick(()=>{})
      );
    },

    async getHeartStatus() {
      await EventService.getHeartStatus(this.memory.StoryID, this.user.UserID)
      .then(
        (heartStatus => {
          this.heartTotal = heartStatus.output.heartTotal;
          if(heartStatus.recordset[0].HeartCount > 0) {
          this.$set(this, "heartStatus", true);
          } else {
            this.$set(this, "heartStatus", false);
          }

        }).bind(this)
      )
            .then (
        this.$nextTick(()=>{})
      )
    },

      async getCommentTotal() {
        EventService.getCommentTotal(this.memory.StoryID)
      .then(
        (commentTotal => {
        if (commentTotal > 0) {
          this.$set(this, "commentTotal", commentTotal);
        }
        }).bind(this)
      )
            .then (
        this.$nextTick(()=>{})
      )
    },

    async openMemory(storyID) {
        this.editMemory = true;
        EventService.getThisStory(storyID)
      .then(
        (memory => {
          this.$set(this, "memory", memory[0]);
        }).bind(this)
      )
      .then (
        this.$nextTick(()=>{this.$forceUpdate();})
      )
    },

      async changeHeartStatus() {
    if(this.heartStatus === false){
      await EventService.addHeartStatus(this.memory.StoryID, this.user.UserID)
        .then(() => {
          this.getHeartStatus();
        })
      } else
     {
      await EventService.removeHeartStatus(this.memory.StoryID, this.user.UserID)
      .then(() => {
        this.getHeartStatus();
     })
     }
  },

      async addComment() {
        this.commentDialog = false
      await EventService.addComment(this.memory.StoryID, this.user.UserID, this.commentText)
        .then(() => {
         this.readerKey = this.readerKey + 1
          this.getCommentTotal();
        })
  },
  }
}

</script>
<style lang="scss" scoped>
pre {
    overflow-x: auto;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
}

.active {
  cursor: pointer;
}
.card-content {
  padding-top: 50px;
  margin-top: 200px;
  position: absolute;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.35);
  top: 0;
  padding: 10px;
  width: 100%;
  }

.layout.row.wrap.mb-3 {
    background-color: white !important;

}

  .feedMedia {
    height: 15em;
  }

  .imageTag {
    margin-top: 5px;
    object-fit: "contain";
    justify-content: center;

  }

    .mediaDiv {
    max-height: 10%;
    margin-top: 5px;
    justify-content: center;
  }

  .storyCard {
    margin-bottom: 7px;
  }

  .storyHeight {
    max-height: 20em;
    overflow: clip;

  }
  .storySummary {
    height: 1.5em;
    justify-content: left;
  }
 
  .isVisible {
    position: relative;
  }
  .videoTag {
      max-height: 45vw;
    margin-top: 5px;
    justify-content: center;
  }
  .videoDiv {
      max-width: 60%;

    margin-top: 5px;
    justify-content: center;
  }

  span {
    font-size: 18px;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
    right: 0;
  }
  h2 {
    margin-top: 10px;
  }



</style>